var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-field" }, [
    _c("label", { staticClass: "contactum-label" }, [
      _vm._v(_vm._s(_vm.field.title))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contactum-range-preview" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.value,
            expression: "value"
          }
        ],
        staticClass: "contactum-range-slider-preview",
        attrs: {
          type: "range",
          min: _vm.minValue,
          max: _vm.maxValue,
          step: _vm.stepValue
        },
        domProps: { value: _vm.value },
        on: {
          __r: function($event) {
            _vm.value = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "contactum-range-preview-val" }, [
        _vm._v(_vm._s(_vm.prefix) + _vm._s(_vm.value) + _vm._s(_vm.suffix))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }